module.exports = __webpack_public_path__ + "img/kc-logo-panel-blue.ffcac92c.png";